import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "./../imgs/logo@2x.png";
import contactImg from "./../imgs/mail_gracias@2x.png";
import tinstagram from "./../imgs/Instagram pie-2@2x.png";
import tfacebook from "./../imgs/Instagram pie-3@2x.png";
import ttwitter from "./../imgs/Instagram pie-4@2x.png";
import "./thanks.css";
import ReactGA from "react-ga";

class Thanks extends Component {
  constructor(props) {
    super(props);
    ReactGA.ga("send", "pageview", window.location.hash);
  }
  render() {
    return (
      <div className="thanks">
        <div className="thanks-bar">
          <div className="thanks-bar-logo">
            <img src={logo} />
          </div>
          <div className="thanks-bar-options">
            <div className="thanks-bar-option1 montserrat fw-bold">
              <Link to="/">WEB</Link>
            </div>
            <div className="thanks-bar-option2 montserrat fw-bold">
              <Link to="/Blog">BLOG</Link>
            </div>
          </div>
        </div>
        <div className="thanks-content">
          <div className="thanks-content-card">
            <img className="thanks-img" src={contactImg} />
            <div className="thanks-main-text fw-bold montserrat">
              <p>
                Gracias por contactarnos en breve un asesor se comunicará
                contigo.
              </p>
            </div>
            <div className="thanks-sub-text fw-bold montserrat">
              <p>Visita Nuestras Redes Sociales</p>
            </div>
            <div className="thanks-redes">
              <a href="https://www.instagram.com/adivorpuebla/?hl=es">
                <img src={tinstagram} />
              </a>
              <a href="https://www.facebook.com/AdivorPuebla/" target="_blank">
                <img src={tfacebook} />
              </a>
              <a href="https://twitter.com/AdivorPuebla">
                <img src={ttwitter} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Thanks;



// WEBPACK FOOTER //
// ./src/sections/Thanks.js